import { render, staticRenderFns } from "./ViewSlider.vue?vue&type=template&id=3dc9316e"
import script from "./ViewSlider.vue?vue&type=script&lang=js"
export * from "./ViewSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports